import { defineStore } from 'pinia';
import { ref, watch } from 'vue';

import { useChat } from '@/stores/chat';

export const useDialog = defineStore('dialog', () => {
  const activeModalCount = ref(0);
  const chat = useChat();

  watch(activeModalCount, (newCount, oldCount) => {
    if (newCount > oldCount) {
      chat.registerSuppression();
    } else if (newCount < oldCount) {
      chat.unregisterSuppression();
    }
  });

  return { activeModalCount };
});
